import { render } from "./sf-accordion.vue?vue&type=template&id=334921ec&scoped=true&ts=true"
import script from "./sf-accordion.vue?vue&type=script&lang=ts"
export * from "./sf-accordion.vue?vue&type=script&lang=ts"

import "./sf-accordion.vue?vue&type=style&index=0&id=334921ec&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-334921ec"]])

export default __exports__